import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { noop } from 'ui-components/default-props/noop';

import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { usePickList } from '../hooks/use-pick-list';

export const PickList = ({ fulfillmentPlanIds, onClick: onClickProp = noop }) => {
  const { onClick: onClickHook, onDownload, onPrint, isFeatureEnabled, isDisabled } = usePickList({ fulfillmentPlanIds });

  const printSettings = usePrintSettings(DocumentType.PickList.printSettingKey);

  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  const onClick = useCallback(() => {
    onClickHook();
    onClickProp();
  }, [onClickProp, onClickHook]);

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      isFeatureEnabled={isFeatureEnabled}
      name={DocumentType.PickList.documentNameTranslation}
      onClick={onClick}
    />
  );
};

PickList.propTypes = {
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
};
